import React from 'react';

const Pending = () => {
  return (
    <div>
      <h1>Pagamento pendente!</h1>
      <p>Seu pagamento está sendo processado. Você receberá uma confirmação em breve.</p>
    </div>
  );
};

export default Pending;